<script>

import Multiselect from 'vue-multiselect'
import { periodicTasksIntervalScheduleMethods } from '@state/helpers'
import IntervalScheduleForm from "@components/scheduled-tasks/interval-schedule/form";
import IntervalScheduleDelete from "@components/scheduled-tasks/interval-schedule/delete";


export default {
  name: 'IntervalScheduleSelector',
  components: {Multiselect , IntervalScheduleForm, IntervalScheduleDelete},
  props: {
    value: {
      required: false,
      default: ()=>(''),
    },
  },
  data() {
    return {
      loading: false,
      showForm: false,
      showDelete: false,
      toUpdate: {},
      toDelete: {},
      periodicTasksIntervalScheduleOptions: [],
      loadingPeriodicTasksIntervalScheduleOptions: false,
      periodicTasksIntervalScheduleOptionsMounted: true,
      periodicTasksIntervalScheduleOptionsCache: []
    }
  },
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  },

  mounted: function () {
    let context = this
    context.populatePeriodicTasksIntervalScheduleOptions()
  },

  methods: {
    ...periodicTasksIntervalScheduleMethods,

    populatePeriodicTasksIntervalScheduleOptions(searchQuery){
      let context = this
      context.loadingPeriodicTasksIntervalScheduleOptions = true
      let reqParams = context.$select_params(searchQuery)
      // reqParams = `${reqParams}${!reqParams ? '?' : '&'}customer=${context.form.customer}`
      const promise = context.fetchPeriodicTasksIntervalSchedule(reqParams)
      return promise.then(data => {
          let listOptions = []
          data.results.forEach(opt => {
              listOptions.push({
                  'url': opt.url,
                  'name': opt.name
              })
          });
          context.periodicTasksIntervalScheduleOptions = listOptions
          context.loadingPeriodicTasksIntervalScheduleOptions = false
          context.periodicTasksIntervalScheduleOptionsMounted = true
      }).catch(error => {
          context.$axios_error_noty(error, context)
          context.loadingPeriodicTasksIntervalScheduleOptions = false
          context.periodicTasksIntervalScheduleOptionsMounted = true
      })
    },

    asyncFindPeriodicTasksIntervalSchedule: _.debounce(function (searchQuery) {
        this.populatePeriodicTasksIntervalScheduleOptions(searchQuery)
    }, 600),

    labelOfPeriodicTasksIntervalSchedule(opt){
      let context = this
      let optionFound = context.periodicTasksIntervalScheduleOptions.find(x => x.url === opt)
      if (!optionFound){
          let cacheFound = context.periodicTasksIntervalScheduleOptionsCache.find(x => x.url === opt)
          return  cacheFound ? cacheFound.name : context.periodicTasksIntervalScheduleOptionsMounted ? `No encontrado en las opciones: ${opt}`: ''
      }else{
          if (context.inputVal === opt){
              if (!context.periodicTasksIntervalScheduleOptionsCache.find(x => x.url === opt)){
                  context.periodicTasksIntervalScheduleOptionsCache.push(optionFound)
              }
          } 
          return optionFound.name
      }
    },
    
  },
}
</script>

<template>
  <b-container class="p-0">
    <b-row v-if="loading">
      <b-col md="12">
        <div class="text-center">
          <b-spinner
            label="Spinning"
            style="color: #195db2; width: 4rem; height: 4rem"
          ></b-spinner>
        </div>
      </b-col>
    </b-row>
    <b-form-group v-else label="Seleccionar intervalo">
      <b-row>
        <b-col md="9">
          <Multiselect
              id="interval-schedule-select"
              v-model="inputVal"
              :multiple="false"
              :options="periodicTasksIntervalScheduleOptions.map(x => x.url)" 
              :custom-label="opt => labelOfPeriodicTasksIntervalSchedule(opt)"
              :loading="loadingPeriodicTasksIntervalScheduleOptions"
              :internal-search="false"
              @search-change="asyncFindPeriodicTasksIntervalSchedule">
          </Multiselect>
        </b-col>
        <b-col md="3" class="justify-content-center align-self-center">
          <b-button-group size="xs">
            <b-button
              variant="primary"
              size="xs"
              :disabled="showForm || showDelete ? true : false"
              @click="()=>{showForm=true; toUpdate={}}">
              <i class="fe-plus"></i>
            </b-button>  
            <b-button
              v-if="inputVal"
              variant="warning"
              size="xs"
              :disabled="showForm || showDelete ? true : false"
              @click="()=>{showForm=true; toUpdate={url:inputVal}}">
              <i class="fe-edit"></i>
            </b-button>    
            <!-- <b-button
              v-if="inputVal"
              variant="danger"
              size="xs"
              :disabled="showForm || showDelete ? true : false"
              @click="()=>{showDelete=true; toDelete={url:inputVal}}">
              <i class="fe-x"></i>
            </b-button> -->
          </b-button-group>
        </b-col>
      </b-row>
    </b-form-group>

    <IntervalScheduleForm 
      v-if="showForm"
      :instanceJson="toUpdate || {}"
      :oncomplete="(selectedObj)=>{
        showForm=false;
        toUpdate={};
        populatePeriodicTasksIntervalScheduleOptions(); inputVal = selectedObj}"
      :oncancel="()=>{
        showForm=false;
        toUpdate={}}">
    </IntervalScheduleForm>

    <IntervalScheduleDelete 
      v-if="showDelete"
      :instanceJson="toDelete || {}"
      :oncomplete="(selectedObj)=>{
        showDelete=false;
        toDelete={};
        inputVal=null;
        populatePeriodicTasksIntervalScheduleOptions()}"
      :oncancel="()=>{
        showDelete=false;
        toDelete={};
        populatePeriodicTasksIntervalScheduleOptions()}">
    </IntervalScheduleDelete>

  </b-container>
</template>
<style lang="scss">
</style>